import EscapeManager from '../../../js/Managers/EscapeManager.js';

class SiteWideNavDropdown extends HTMLElement {
  /*container: HTMLDivElement;
  button: HTMLButtonElement;
  buttonText: HTMLSpanElement;
  inputs: NodeListOf<HTMLInputElement>;
  title: string;
  open: Boolean;*/
  escapeManagerID = 'sitewide-nav-dropdown';
  #open = false;

  constructor() {
    super();

    this.container = this.querySelector('.sitewide-nav__dropdown__content');
    this.button = this.querySelector('.sitewide-nav__dropdown__button');

    this._listenForOutsideClick = this.listenForOutsideClick.bind(this);
    this._onButtonClick = this.onButtonClick.bind(this);
  }

  connectedCallback() {
    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  addEventListeners() {
    this.button.addEventListener('click', this._onButtonClick);
  }
  removeEventListeners() {
    this.button.removeEventListener('click', this._onButtonClick);
  }

  onButtonClick() {
    this.toggle();
  }

  #openContainer() {
    this.button.setAttribute('aria-expanded', 'true');
    this.container.removeAttribute('hidden');

    EscapeManager.add(this.escapeManagerID, () => {
      this.#closeContainer();
    });
    this.addOpenListeners();
  }

  #closeContainer() {
    this.button.setAttribute('aria-expanded', 'false');
    this.container.setAttribute('hidden', '');

    EscapeManager.remove(this.escapeManagerID);
    this.removeOpenListeners();
  }

  get open() {
    return this.#open;
  }

  set open(value) {
    this.#open = value;

    if (this.#open) {
      this.#openContainer();
    } else {
      this.#closeContainer();
    }
  }

  toggle() {
    this.open = !this.open;
  }

  listenForOutsideClick(evt) {
    if (!this.contains(evt.target)) {
      this.#closeContainer();
    }
  }

  addOpenListeners() {
    document.addEventListener('click', this._listenForOutsideClick);
  }
  removeOpenListeners() {
    document.removeEventListener('click', this._listenForOutsideClick);
  }
}

customElements.define('sitewide-nav-dropdown', SiteWideNavDropdown);
